module.exports = __webpack_public_path__ + "img/logo.8fac0716.png";